import {
  ALL_USER_DETAILS_FAIL,
  ALL_USER_DETAILS_REQUEST,
  ALL_USER_DETAILS_SUCCESS,
  USER_ADD_FAIL,
  USER_ADD_REQUEST,
  USER_ADD_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_RESET,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_CHANGE_PASS_FAIL,
  USER_CHANGE_PASS_REQUEST,
  USER_CHANGE_PASS_SUCCESS,
  ADMIN_USERS_REQUEST,
  ADMIN_USERS_SUCCESS,
  ADMIN_USERS_FAIL,
  ADMIN_USER_UPDATE_REQUEST,
  ADMIN_USER_UPDATE_SUCCESS,
  ADMIN_USER_UPDATE_FAIL,
  ADMIN_USER_DELETE_REQUEST,
  ADMIN_USER_DELETE_SUCCESS,
  ADMIN_USER_DELETE_FAIL,
  ADMIN_LABS_REQUEST,
  ADMIN_LABS_SUCCESS,
  ADMIN_LABS_FAIL,
  ADMIN_LAB_CREATE_REQUEST,
  ADMIN_LAB_CREATE_SUCCESS,
  ADMIN_LAB_CREATE_FAIL,
  ADMIN_LAB_UPDATE_REQUEST,
  ADMIN_LAB_UPDATE_SUCCESS,
  ADMIN_LAB_UPDATE_FAIL,
  ADMIN_LAB_DELETE_REQUEST,
  ADMIN_LAB_DELETE_SUCCESS,
  ADMIN_LAB_DELETE_FAIL,
} from "../constants/userConstant";

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        loading: true,
      };

    case USER_LOGIN_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };

    case USER_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case USER_LOGOUT:
      return {};

    default:
      return state;
  }
};
export const userRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_REGISTER_REQUEST:
      return {
        loading: true,
      };

    case USER_REGISTER_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };

    case USER_REGISTER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const userAddReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_ADD_REQUEST:
      return {
        loading: true,
      };

    case USER_ADD_SUCCESS:
      return {
        loading: false,
        success: true,
        userInfo: action.payload,
      };

    case USER_ADD_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case USER_DETAILS_SUCCESS:
      return {
        loading: false,
        user: action.payload,
      };

    case USER_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

//reducer to get all user details
export const allUserDetailsReducer = (state = { users: {} }, action) => {
  switch (action.type) {
    case ALL_USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ALL_USER_DETAILS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
      };

    case ALL_USER_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const userUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATE_PROFILE_REQUEST:
      return {
        loading: true,
      };

    case USER_UPDATE_PROFILE_SUCCESS:
      return {
        loading: false,
        success: true,
        user: action.payload,
      };

    case USER_UPDATE_PROFILE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case USER_UPDATE_PROFILE_RESET:
      return {};

    default:
      return state;
  }
};

export const userPasswordChangeReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_CHANGE_PASS_REQUEST:
      return {
        loading: true,
      };

    case USER_CHANGE_PASS_SUCCESS:
      return {
        loading: false,
        success: true,
      };

    case USER_CHANGE_PASS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// ====== ADMIN REDUCERS ======

export const adminUsersReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case ADMIN_USERS_REQUEST:
      return { ...state, loading: true };
    case ADMIN_USERS_SUCCESS:
      return { loading: false, users: action.payload };
    case ADMIN_USERS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const adminUserMutationReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_USER_UPDATE_REQUEST:
    case ADMIN_USER_DELETE_REQUEST:
      return { loading: true };
    case ADMIN_USER_UPDATE_SUCCESS:
    case ADMIN_USER_DELETE_SUCCESS:
      return { loading: false, success: true, message: action.payload?.message };
    case ADMIN_USER_UPDATE_FAIL:
    case ADMIN_USER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const adminLabsReducer = (state = { labs: [] }, action) => {
  switch (action.type) {
    case ADMIN_LABS_REQUEST:
      return { ...state, loading: true };
    case ADMIN_LABS_SUCCESS:
      return { loading: false, labs: action.payload };
    case ADMIN_LABS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const adminLabMutationReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_LAB_CREATE_REQUEST:
    case ADMIN_LAB_UPDATE_REQUEST:
    case ADMIN_LAB_DELETE_REQUEST:
      return { loading: true };
    case ADMIN_LAB_CREATE_SUCCESS:
    case ADMIN_LAB_UPDATE_SUCCESS:
    case ADMIN_LAB_DELETE_SUCCESS:
      return { loading: false, success: true, message: action.payload?.message };
    case ADMIN_LAB_CREATE_FAIL:
    case ADMIN_LAB_UPDATE_FAIL:
    case ADMIN_LAB_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
